import {
  CompletedReviewsSort,
  exportCompletedReviewsCSV,
  getCompletedReviews,
} from '../../services/MetricsDashboardService'
import useAdminReviewsPage from '../../hooks/useAdminReviewsPage'
import ReviewsFilters from '../molecules/dashboard/ReviewsFilters'
import CompletedReviewsTable from '../molecules/dashboard/CompletedReviewsTable'
import InfoTooltip from '../atoms/InfoTooltip'
import { BackLink } from '../organisms/BackLink'
import { CompletedReview } from '../../types/metrics'

const SORT_FIELDS = ['finishDate', 'periodName', 'talentRank', 'averageScore', 'reviewerName', 'employeeName'] as const

const AdminCompletedReviews = (): JSX.Element => {
  const { filtersProps, tableProps } = useAdminReviewsPage<CompletedReview, CompletedReviewsSort>({
    sortFields: SORT_FIELDS,
    fetchPage: getCompletedReviews,
    exportFn: exportCompletedReviewsCSV,
    errorMessage: 'Could not load completed reviews.',
  })

  return (
    <main className="container mx-auto pb-16">
      <BackLink />
      <section className="mt-10 flex flex-col gap-6">
        <div className="flex items-center gap-2">
          <h1 className="text-5xl font-semibold text-dark-blue">Completed Reviews</h1>
          <InfoTooltip text="All finished reviews across the platform — filterable by period, reviewer, or employee, and sortable by finish date, talent rank, or score." />
        </div>
        <ReviewsFilters idPrefix="completed-reviews" {...filtersProps} />
        <CompletedReviewsTable {...tableProps} />
      </section>
    </main>
  )
}

export default AdminCompletedReviews
